import React from 'react'
import styled from 'styled-components';
import Icon from '../Icon';
import IconText from '../MobileFooterMenu/IconText';

const StyledCustomerServiceLink = styled.div`
    display: flex;
    flex-direction: column;
`

const StyledCustomerServiceIcon = styled(Icon)`
  font-size: 2rem;
  cursor: pointer;
`;

const CustomerServiceLink = () => {
    return (
        <StyledCustomerServiceLink className='flex items-center gap-1'>
            <StyledCustomerServiceIcon name='headset' />
            <IconText translationKey='general.customer-service-desktop' />
        </StyledCustomerServiceLink>
    )
}

export default CustomerServiceLink